import { risapi, getAxiosConfig } from './risapi';

/**
 * Fetches award suggestions for a specific date range.
 * @param {object} data - The request data, e.g., { start_date: 'YYYY-MM-DD', end_date: 'YYYY-MM-DD' }.
 * @param {function} callback The function to call with the response.
 */
export const generatePeriodicAwards = async (data, callback) => {
    try {
        const response = await risapi.post('/api/awards/generate-periodic', data, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

/**
 * Fetches annual award suggestions for a specific year.
 * @param {object} data - The request data, e.g., { year: 2025 }.
 * @param {function} callback - The function to call with the response.
 */
export const generateAnnualAwards = async (data, callback) => {
    try {
        const response = await risapi.post('/api/awards/generate-annual', data, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

/**
 * Saves the confirmed list of new awards to the database.
 * @param {object} data - The request data, e.g., { awards: [...] }.
 * @param {function} callback - The function to call with the response.
 */
export const saveAwards = async (data, callback) => {
    try {
        const response = await risapi.post('/api/awards', data, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};


/**
 * Fetches all awards for the currently logged-in user.
 * @param {function} callback The function to call with the response.
 */
export const getMyAwards = async (callback) => {
    try {
        const response = await risapi.get('/api/my-awards', getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};